import { ReviewDealerEmail } from '../../styles'

interface ReviewDealerEmailCellProps {
  email: string
}

function ReviewDealerEmailCell({ email }: ReviewDealerEmailCellProps) {
  if (!email) return null
  return <ReviewDealerEmail>{email}</ReviewDealerEmail>
}

export default ReviewDealerEmailCell
